import { Box, Text, Button, Flex, Link } from 'theme-ui';
import PropTypes from 'prop-types';
import ImgLoader from '~/components/Generic/ImgLoader';

const SimpleArticleCard = ({ article }) => {
  return (
    <Flex
      as="article"
      sx={{
        flexDirection: ['column', null, 'row'],
        alignItems: [null, null, 'center'],
        ':not(:last-of-type)': { mb: ['8.4rem', null, '3.1rem'] },
        '.gatsby-plugin-image-wrapper': {
          overflow: 'hidden',
          WebkitMaskImage: '-webkit-radial-gradient(white, black)',
        },
        ':first-of-type .gatsby-plugin-image-wrapper': { borderTopLeftRadius: [null, null, '50px'] },
        ':last-of-type .gatsby-plugin-image-wrapper': { borderBottomRightRadius: [null, null, '180px'] },
      }}
    >
      <Link to={`${article.slug}/`} sx={{ flex: [null, null, '1 1 0'] }}>
        <ImgLoader
          image={article.image}
          sx={{
            height: ['33.4rem', '50.8rem', '45.7rem'],
            borderRadius: ['25px 0 50px', null, 0],
            mb: ['3.5rem', '6.1rem', 0],
            mx: [null, 'calc(var(--horizontal-inset) / 2)', 0],
            mr: [null, null, '7.2re'],
          }}
        />
      </Link>

      <Box
        as="header"
        sx={{ px: ['var(--horizontal-inset)', null, 0], width: '100%', maxWidth: [null, null, '41.4rem'] }}
      >
        <Text as="h3" variant="h3" sx={{ mb: ['3.8rem'] }}>
          {article.title}
        </Text>

        <div
          dangerouslySetInnerHTML={{ __html: article.description.childMarkdownRemark.html }}
          sx={{ mb: ['3.8rem'] }}
        />

        <Button
          as={Link}
          to={`${article.slug}/`}
          sx={{ variant: ['buttons.primary', 'buttons.primary.small'], width: '100%' }}
        >
          Learn More
        </Button>
      </Box>
    </Flex>
  );
};

SimpleArticleCard.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    body: PropTypes.shape({}),
    description: PropTypes.shape({}),
    image: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
};

export default SimpleArticleCard;
